import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;

  display: flex;

  background-color: ${colors.surface};

  /* Acima do breakpoint mobile, a tela toda fica travada em 100vh --
     só o FormSide rola por dentro (overflow-y: auto), então o Hero
     (sem formulário) fica sempre visível por inteiro, sem acompanhar
     o scroll. Abaixo do breakpoint o Hero já some (ver componente
     Hero) e o comportamento continua o de sempre (página inteira
     rola). */
  @media (min-width: 1200px) {
    height: 100vh;
    overflow: hidden;
  }

  @media (max-width: 1199px) {
    flex-direction: column;
  }
`;

export const Hero = styled.div`
  position: relative;
  overflow: hidden;

  flex: 0 0 42%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  padding: 64px;

  background: linear-gradient(
    135deg,
    ${colors.surfaceContainerLow} 0%,
    ${colors.surface} 60%
  );

  &::before {
    content: '';
    position: absolute;
    top: -120px;
    right: -120px;
    width: 320px;
    height: 320px;
    border-radius: 50%;
    background: ${colors.primary}22;
    filter: blur(80px);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -100px;
    left: -100px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background: ${colors.primary}14;
    filter: blur(90px);
  }

  @media (max-width: 1199px) {
    display: none;
  }
`;

export const HeroBrand = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  align-items: center;
  gap: 12px;

  margin-bottom: 48px;

  img {
    width: 36px;
    height: 36px;
  }

  span {
    font-size: 20px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurface};
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 480px;
`;

export const HeroEyebrow = styled.span`
  display: block;
  margin-bottom: 16px;

  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: ${colors.primary};
`;

export const HeroTitle = styled.h1`
  font-size: 44px;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
  color: ${colors.onSurface};
  margin-bottom: 24px;

  span {
    color: ${colors.primary};
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: ${colors.onSurfaceVariant};
  border-left: 2px solid ${colors.primary};
  padding-left: 20px;
`;

export const FormSide = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  /* "safe" faz o navegador cair pro alinhamento pelo início quando o
     conteúdo não cabe, em vez de centralizar e cortar as duas pontas
     de um jeito que o scroll não alcança (bug clássico de
     justify-content: center + overflow: auto). Navegador sem suporte
     a "safe" ignora a linha e mantém o "center" puro de cima. */
  justify-content: safe center;
  align-items: center;

  padding: 48px 24px;
  overflow-y: auto;

  @media (min-width: 1200px) {
    padding: 48px;

    /* Sem isso, um item flex tende a crescer pro tamanho do próprio
       conteúdo (min-height: auto) em vez de respeitar a altura travada
       do Container -- daí o formulário empurrando pra fora do
       overflow: hidden em vez de rolar por dentro. */
    min-height: 0;
  }
`;

interface FormContentProps {
  wide?: boolean;
}

export const FormContent = styled.div<FormContentProps>`
  width: 100%;
  max-width: ${({ wide }) => (wide ? '720px' : '440px')};

  background-color: ${colors.surfaceContainerLow}66;
  border: 1px solid ${colors.outlineVariant}1a;
  border-radius: ${radius.lg};
  backdrop-filter: blur(16px);

  padding: 32px;

  @media (max-width: 599px) {
    background-color: transparent;
    border: none;
    padding: 0;
  }
`;

export const MobileBrand = styled.div`
  display: none;

  align-items: center;
  gap: 10px;
  margin-bottom: 40px;

  img {
    width: 32px;
    height: 32px;
  }

  span {
    font-size: 18px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.primary};
  }

  @media (max-width: 1199px) {
    display: flex;
  }
`;
